import { render } from "./PrivatePolitic.vue?vue&type=template&id=34c0771e"
import script from "./PrivatePolitic.vue?vue&type=script&lang=js"
export * from "./PrivatePolitic.vue?vue&type=script&lang=js"

import "./PrivatePolitic.vue?vue&type=style&index=0&id=34c0771e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__